import { render, staticRenderFns } from "./CardPrice.vue?vue&type=template&id=1ec99be1&scoped=true&"
import script from "./CardPrice.vue?vue&type=script&lang=js&"
export * from "./CardPrice.vue?vue&type=script&lang=js&"
import style0 from "./CardPrice.vue?vue&type=style&index=0&id=1ec99be1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec99be1",
  null
  
)

export default component.exports